import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator, ColumnComponent, CellComponent } from "tabulator-tables";
import Select from "react-select";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { IMqttModel, IVisaoGeralModel } from "../modules/services/core/_models";
import { RequestMethod } from "../modules/services/core/_enums";
import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import L from "leaflet";
import moment from "moment";
import { useAuth } from "../modules/auth/core/Auth";
import { useLocation } from "react-router-dom";


function isEmpty(str: string) {
  return (!str || str.length === 0);
};

const MenuMqtt: React.FC = () => {
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const httpClient = useHttpClient();
  const configTableRef = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);
  const configTableRefInstance = useRef<any>(null);
  const mainTableRef = useRef<any>(null);
  const [Mqtt, setMqtt] = useState<IMqttModel[]>([]);
  const [filteredVisao, setFilteredVisao] = useState<IMqttModel[]>([]);
  const [filtros, setFiltros] = useState<any>({});
  const [filteredRowCount, setFilteredRowCount] = useState<number>(0);
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>([]);
  const [initialOrganizations, setInitialOrganizations] = useState<string[]>([]);
  const [activeTab, setActiveTab] = useState('mapa');
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [selectedPayload, setSelectedPayload] = useState<IMqttModel | null>(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const mapRef = useRef<L.Map | null>(null);
  const markersGroup = useRef<L.LayerGroup | null>(null);
  const { auth } = useAuth();
  const user = auth?.User;
  const emailUsuario = user?.Email;

  console.log("Email do usuário:", emailUsuario);

  const [userId, setUserId] = useState<string>("");
  const [availableOrganizations, setAvailableOrganizations] = useState<Organization[]>([]);
  const [selectedGateways, setSelectedGateways] = useState<string[]>([]);
  const [selectedAtivos, setSelectedAtivos] = useState<string[]>([]);
  const [availableGateways, setAvailableGateways] = useState<any[]>([]);
  const [availableAtivos, setAvailableAtivos] = useState<any[]>([]);

  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [selectedRows, setSelectedRows] = useState<number>(20);

  const pageOptions = Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: `Página ${i + 1}` }));
  const rowOptions = [
    { value: 20, label: '20 linhas' },
    { value: 40, label: '40 linhas' },
    { value: 100, label: '100 linhas' }
  ];

  interface IMQTTPayloadRequest {
    Corporacao?: string;
    DataAte?: string;
    organicoes?: string[];
    Ativos?: string[];
    Gateways?: string[];
  }

  interface IUser {
    Id: number;
    Name: string;
    Email: string;
  }

  interface Organization {
    OrganizationId: string;
    OrganizationName: string;
  }

  // Processar parâmetros da URL
  const urlParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const orgParam = searchParams.get('org');
    return orgParam ? orgParam.split(',') : [];
  }, [location.search]);

  // Inicializar com organizações
  const initializeWithOrganizations = useCallback(async (organizations: string[]) => {
    try {
      await fetchMqttData({ organicoes: organizations }, selectedPage, selectedRows);
      setSelectedOrganizations(organizations);
    } catch (error) {
      console.error("Erro ao inicializar com organizações:", error);
    }
  }, [selectedPage, selectedRows]);

  // Efeito para inicialização de dados do usuário
  useEffect(() => {
    const initializeUserData = async () => {
      if (!emailUsuario || isInitialized) return;

      try {
        const id = await fetchUserId();
        if (id) {
          await fetchUserOrganizations(id);
          await obterListaGateway();
          await obterListaAtivo();
          setIsInitialized(true);
        }
      } catch (error) {
        console.error("Erro ao inicializar dados do usuário:", error);
      }
    };

    initializeUserData();
  }, [emailUsuario, isInitialized]);

  // Efeito para aplicar filtros da URL
  useEffect(() => {
    if (isInitialized && urlParams.length > 0 && !selectedOrganizations.length) {
      initializeWithOrganizations(urlParams);
    }
  }, [isInitialized, urlParams, selectedOrganizations.length, initializeWithOrganizations]);

  // Modifique a função fetchMqttData para incluir um log mais detalhado
  const fetchMqttData = async (filters: Partial<IMQTTPayloadRequest> = {}, page = selectedPage, rows = selectedRows) => {
    try {
      console.log("Iniciando fetchMqttData com:", { filters, page, rows });

      const payload = {
        Corporacao: filters.Corporacao || "Raizen",
        DataAte: filters.DataAte || moment().format("YYYY-MM-DD HH:mm:ss"),
        organicoes: Array.isArray(filters.organicoes) && filters.organicoes.length > 0 ? filters.organicoes : ["Todos"],
        Ativos: Array.isArray(filters.Ativos) && filters.Ativos.length > 0 ? filters.Ativos : ["Todos"],
        Gateways: Array.isArray(filters.Gateways) && filters.Gateways.length > 0 ? filters.Gateways : ["Todos"]
      };

      console.log("Payload preparado:", payload);

      const response = await fetch(`${backendUrl}/api/TrackingMQTT/MQTTPayload?rows=${rows}&page=${page}`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json-patch+json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro HTTP ${response.status}: ${errorText}`);
      }

      const responseData = await response.json();
      console.log("Dados recebidos:", responseData);

      if (!Array.isArray(responseData)) {
        throw new Error('Resposta não é um array');
      }

      const mqttData = responseData.map(item => ({
        ...item,
        Latitude: parseFloat(item.Latitude),
        Longitude: parseFloat(item.Longitude)
      }));

      setMqtt(mqttData);
      return mqttData;
    } catch (error) {
      console.error("Erro na requisição MQTT:", error);
      setMqtt([]);
      return [];
    }
  };

  const fetchUserId = async () => {
    if (!emailUsuario) {
      console.log("Email do usuário não disponível");
      return;
    }

    try {
      const url = `${backendUrl}/api/User/ByEmail/${encodeURIComponent(emailUsuario)}`;
      console.log("Fazendo requisição para:", url);

      const response = await fetch(url);
      console.log("Status da resposta:", response.status);

      if (response.ok) {
        const userId = await response.json();
        console.log("Dados do usuário:", userId);
        setUserId(userId.toString());
        return userId.toString();
      } else {
        const errorText = await response.text();
        console.error("Erro ao buscar ID do usuário. Status:", response.status, "Texto:", errorText);
      }
    } catch (error) {
      console.error("Erro ao buscar ID do usuário:", error);
    }
  };

  // Nova função para buscar organizações do usuário
  const fetchUserOrganizations = async (id: string) => {
    if (!id) {
      console.log("ID do usuário não disponível");
      return;
    }

    try {
      const url = `${backendUrl}/api/UserOrganization/OrgByUser?userId=${id}`;
      console.log("Fazendo requisição para:", url);

      const response = await fetch(url);
      console.log("Status da resposta:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Organizações recebidas:", data);

        if (Array.isArray(data) && data.length > 0) {
          setAvailableOrganizations(data);
          const orgNames = data.map((org: Organization) => org.OrganizationName);
          console.log("Nomes das organizações:", orgNames);
          setInitialOrganizations(orgNames);
        } else {
          console.log("Nenhuma organização encontrada ou formato inválido:", data);
        }
      } else {
        const errorText = await response.text();
        console.error("Erro ao buscar organizações. Status:", response.status, "Texto:", errorText);
      }
    } catch (error) {
      console.error("Erro ao buscar organizações:", error);
    }
  };

  const dataSetNamePBI = getDataSetNamePBI();

  const obterListaAtivo = async () => {
    try {
      const endpoint = '/Gerenciamento/PowerBI/ObterAtivos';
      const queryParams = new URLSearchParams();
      if (dataSetNamePBI) {
        queryParams.append('datasetName', dataSetNamePBI);
      }

      const queryString = queryParams.toString();
      const fullUrl = `${endpoint}?${queryString}`;

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: fullUrl,
      });

      if (response.success && response.payload) {
        const ativos = response.payload.map((item: any) => ({
          value: item.Ativo,
          label: item.Ativo
        }));
        setAvailableAtivos(ativos);
      }
    } catch (error) {
      console.error("Erro ao obter lista de ativos:", error);
    }
  };

  const obterListaGateway = async () => {
    try {
      const endpoint = '/Gerenciamento/PowerBI/ObterGateways';
      const queryParams = new URLSearchParams();
      if (dataSetNamePBI) {
        queryParams.append('datasetName', dataSetNamePBI);
      }

      const queryString = queryParams.toString();
      const fullUrl = `${endpoint}?${queryString}`;

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: fullUrl,
      });

      if (response.success && response.payload) {
        const gateways = response.payload.map((item: any) => ({
          value: item.Gateway,
          label: item.Gateway
        }));
        setAvailableGateways(gateways);
      }
    } catch (error) {
      console.error("Erro ao obter lista de gateways:", error);
    }
  };

  // Funções de filtro
  const createInputFilterEditor = (field: keyof IMqttModel) => (cell: any, onRendered: any, success: any, cancel: any) => {
    const container = document.createElement("div");
    container.style.position = "relative";

    const input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", "Buscar...");
    input.classList.add("filter-input");

    const suggestionList = document.createElement("div");
    suggestionList.classList.add("suggestion-list");
    suggestionList.style.position = "absolute";
    suggestionList.style.top = "100%";
    suggestionList.style.left = "0";
    suggestionList.style.right = "0";
    suggestionList.style.zIndex = "1000";
    suggestionList.style.maxHeight = "200px";
    suggestionList.style.overflowY = "auto";
    suggestionList.style.display = "none";

    document.body.appendChild(suggestionList);

    const updateSuggestions = (filterText: string) => {
      const uniqueValues = Array.from(new Set(Mqtt.map((item) => item[field])));
      const filteredValues = uniqueValues.filter((value) =>
        value?.toString().toLowerCase().includes(filterText.toLowerCase())
      );

      suggestionList.innerHTML = "";
      filteredValues.forEach((value) => {
        const suggestionItem = document.createElement("div");
        suggestionItem.textContent = value?.toString() || '';
        suggestionItem.classList.add("suggestion-item");
        suggestionItem.addEventListener("click", () => {
          input.value = value?.toString() || '';
          suggestionList.style.display = "none";
          success(value);
        });
        suggestionList.appendChild(suggestionItem);
      });

      if (filteredValues.length > 0) {
        suggestionList.style.display = "block";
      } else {
        suggestionList.style.display = "none";
      }
    };

    input.addEventListener("input", (e) => {
      const filterText = (e.target as HTMLInputElement).value;
      updateSuggestions(filterText);

      const rect = input.getBoundingClientRect();
      suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
      suggestionList.style.left = `${rect.left + window.scrollX}px`;
      suggestionList.style.width = `${rect.width}px`;
    });

    input.addEventListener("focus", () => {
      updateSuggestions(input.value);

      const rect = input.getBoundingClientRect();
      suggestionList.style.top = `${rect.bottom + window.scrollY}px`;
      suggestionList.style.left = `${rect.left + window.scrollX}px`;
      suggestionList.style.width = `${rect.width}px`;
    });

    document.addEventListener("click", (e) => {
      if (!container.contains(e.target as Node)) {
        suggestionList.style.display = "none";
      }
    });

    container.appendChild(input);
    return container;
  };

  const createInputFilterFunction = (field: string) => (headerValue: string, rowValue: string) => {
    if (!headerValue) return true;
    return rowValue?.toString().toLowerCase().includes(headerValue.toLowerCase());
  };

  const loadConfigTable = () => {
    const cols = mainTableRef.current.getColumns().map((col: ColumnComponent, index: number) => ({
      id: index + 1,
      title: col.getDefinition().title || col.getField(),
      field: col.getField(),
      visible: col.isVisible(),
    }));

    const handleDownloadCsv = () => {
      mainTableRef.current.download("csv", "Mqtt.csv");
    };

    if (configTableRef.current) {
      if (configTableRefInstance.current) {
        configTableRefInstance.current.destroy();
      }

      configTableRefInstance.current = new Tabulator(configTableRef.current, {
        data: cols,
        layout: "fitDataFill",
        movableRows: true,
        headerVisible: false,
        rowFormatter: function (row) {
          console.log(row.getData());
          var data = row.getData();
          if (data.id === 1 || data.id === 2 || data.id === 3) {
            row.getElement().style.display = "none";
          }
        },
        columns: [
          {
            title: "Mover",
            formatter: "handle",
            headerSort: false,
            width: 30,
            minWidth: 30,
          },
          {
            title: "Coluna",
            field: "title",
            formatter: (cell) => ` ${cell.getValue()}`,
          },
          {
            title: "Visível",
            field: "visible",
            formatter: "tickCross",
            editor: true,
          },
        ],
      });
    }
  };

  useEffect(() => {
    if (tableRef.current) {
      // Destrua a instância anterior do Tabulator, se existir
      if (mainTableRef.current) {
        mainTableRef.current.destroy();
      }
      mainTableRef.current = new Tabulator(tableRef.current, {
        persistence: true,
        persistenceMode: "local",
        data: Mqtt,
        height: 650,
        movableColumns: true,
        resizableColumnFit: true,
        columnHeaderVertAlign: "top",
        footerElement: `<div id="footer">${Mqtt.length} linhas retornadas (linhas filtradas: 0)</div>`,

        columns: [
          {
            title: 'ID do Tracking', field: 'Readerid', frozen: true,
          },
          {
            title: 'Numero de devices', field: 'Devices', frozen: true, resizable: true, width: 100
          },
          {
            title: "Organização",
            field: "Organizacao",
            sorter: "string",
            headerFilter: "list",
            width: 230,
            headerFilterParams: {
              values: Array.from(new Set(Mqtt.map((item) => item.Organization))),
              multiselect: true
            },
            headerFilterFunc: function (headerValue, rowValue) {
              if (headerValue.length === 0) {
                return true;
              }
              return headerValue.includes(rowValue);
            }
          },
          {
            title: "Gateway",
            field: "Gateway",
            sorter: "string",
            width: 230,
            headerFilter: createInputFilterEditor("Gateway"), // Usa o editor genérico
            headerFilterFunc: createInputFilterFunction("Gateway"), // Usa a função de filtro genérica
            headerFilterPlaceholder: "Buscar...",
          },
          {
            title: "Local",
            field: "Local",
            sorter: "string",
            width: 230,
            headerFilter: createInputFilterEditor("Local"), // Usa o editor genérico
            headerFilterFunc: createInputFilterFunction("Local"), // Usa a função de filtro genérica
            headerFilterPlaceholder: "Buscar...",
          },
          {
            title: "Descrição do Local",
            field: "LocalDescricao",
            width: 230,
            sorter: "string",
            headerFilter: createInputFilterEditor("LocalDescricao"), // Usa o editor genérico
            headerFilterFunc: createInputFilterFunction("LocalDescricao"), // Usa a função de filtro genérica
            headerFilterPlaceholder: "Buscar...",
          },
          {
            field: "Beacon",
            title: "DeviceId",
            width: 210,
            sorter: "string",
            headerFilter: createInputFilterEditor("Beacon"),
            headerFilterFunc: createInputFilterFunction("Beacon"),
            headerFilterPlaceholder: "Buscar...",
            formatter: function (cell, f) {
              return isEmpty(cell.getValue()) ? '<div style="margin: auto; width: 60%; text-align: center;">-</div>' : cell.getValue();
            }
          },
          {
            field: "Ativo",
            title: "Ativo",
            sorter: "string",
            width: 230,
            headerFilter: createInputFilterEditor("Ativo"), // Usa o editor genérico
            headerFilterFunc: createInputFilterFunction("Ativo"), // Usa a função de filtro genérica
            headerFilterPlaceholder: "Buscar...",
          },
          { field: 'AtivoDescricao', title: 'Descrição do ativo', sorter: "string", width: 200 },
        ],
      });
      mainTableRef.current.on("rowClick", function (e: any, row: any) {
        // Remove a classe 'selected' de todas as linhas
        const rows = mainTableRef.current.getRows();
        rows.forEach((r: any) => r.getElement().classList.remove('selected'));

        // Adiciona a classe 'selected' à linha clicada
        row.getElement().classList.add('selected');
      });

      // Função para atualizar o footerElement
      const updateFooter = (totalRows: number, filteredRows: number) => {
        const footer = document.getElementById('footer');
        if (footer) {
          footer.innerHTML = `${totalRows} linhas retornadas (linhas filtradas: ${filteredRows})`;
        }
      };

      // Adicione o evento dataFiltered
      mainTableRef.current.on("dataFiltered", function (filters: any, rows: any[]) {
        updateFooter(Mqtt.length, rows.length);
      });
      mainTableRef.current.on("rowClick", handleRowClick);

      // Observador de mutações para garantir que o footerElement seja atualizado corretamente
      const observer = new MutationObserver(() => {
        updateFooter(Mqtt.length, 0);
      });

      const footer = document.getElementById('footer');
      if (footer) {
        observer.observe(footer, { childList: true });
      }

      // Limpeza do observador quando o componente é desmontado
      return () => {
        if (observer) {
          observer.disconnect();
        }
      };

    }
  }, [Mqtt]);

  const [filteredData, setFilteredData] = useState(Mqtt);
  const [selectedOrganization, setSelectedOrganization] = useState<
    string | null
  >(null);

  const handleFilterChange = (filterType: string, selectedOption: any) => {

    if (filterType === "Organization") {
      setSelectedOrganization(selectedOption ? selectedOption.value : null);
    }

    let filtered = Mqtt;

    if (selectedOption) {
      if (filterType === "Organization") {
        filtered = filtered.filter(
          (alert) => alert.Organization === selectedOption.value
        );
      }
    }
    setFilteredData(filtered);
    console.log(filtered);
  }

  useEffect(() => {
    if (mainTableRef.current) {
      mainTableRef.current.replaceData(Mqtt);
    }
  }, [Mqtt]);

  useEffect(() => {
    fetchMqttData();

  }, []);

  const Organizations = Array.from(new Set(Mqtt.map((item) => item.Organization)));

  const handleSettingsClick = () => {
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      setTimeout(loadConfigTable, 300);
    }
  };

  const handleDownloadCsv = () => {
    if (mainTableRef.current) {
      mainTableRef.current.download("csv", "Mqtt.csv");
    }
  };
  useEffect(() => {
    const filteredRowCount = mainTableRef.current.getData(true).length;
    setFilteredRowCount(filteredRowCount);
  }, [filteredData]);

  const applyConfigChanges = () => {
    const updatedCols = configTableRefInstance.current.getData();

    // Pega todas as colunas da tabela principal
    const allColumns = mainTableRef.current.getColumns();

    // Garante que as 3 primeiras colunas estejam sempre nas primeiras posições
    const frozenColumns = allColumns.slice(0, 3).map((col: ColumnComponent) => col.getDefinition()); // Pegando as definições das 3 primeiras colunas

    // Atualiza as colunas restantes, sem alterar as 3 primeiras
    const newColumns = updatedCols.map((col: any) => {
      const originalCol = mainTableRef.current.getColumn(col.field);
      if (originalCol) {
        const definition = originalCol.getDefinition();
        return {
          ...definition,
          visible: col.visible,
        };
      }
      fetchMqttData();
      return col;
    }).slice(3); // Remove as 3 primeiras colunas da lista de atualizações

    const finalColumns = [...frozenColumns, ...newColumns];

    // Atualiza as colunas da tabela principal
    mainTableRef.current.setColumns(finalColumns);

  };
  const handleTabChange = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);

  const addMarkerToMap = (data: IMqttModel) => {
    if (activeTab !== 'mapa' || !mapRef.current) return;

    if (!markersGroup.current) {
      markersGroup.current = L.layerGroup().addTo(mapRef.current);
    }

    const latitude = data.Latitude && data.Latitude !== 0 ? data.Latitude : 0;
    const longitude = data.Longitude && data.Longitude !== 0 ? data.Longitude : 0;

    markersGroup.current.clearLayers();

    const marker = L.marker([latitude, longitude]);
    const popup = L.popup().setContent(`
      <b>Gateway:</b> ${data.Gateway}<br>
      <b>Local:</b> ${data.Local || "-"}<br>
      <b>Status:</b> ${data.Status || "-"}<br>
      <b>Temperatura:</b> ${data.Temperature ? data.Temperature.toFixed(1) + ' °C' : "-"}<br>
      <b>Última Atualização:</b> ${data.UltimaAtualizacao || "-"}
    `);

    marker.bindPopup(popup).openPopup();
    markersGroup.current.addLayer(marker);

    if (latitude !== 0 && longitude !== 0) {
      mapRef.current.setView([latitude, longitude], 15);
    } else {
      mapRef.current.setView([latitude, longitude], 2);
    }
  };

  const handleRowClick = (e: Event, row: any) => {
    const data = row.getData();
    console.log("Dados do gateway selecionado:", data);
    console.log("Latitude:", data.Latitude);
    console.log("Longitude:", data.Longitude);

    setSelectedPayload(data);
    setDetailsVisible(true);

    if (data.Latitude && data.Longitude && mapRef.current && markersGroup.current) {
      addMarkerToMap(data);
    } else {
      console.warn("Dados faltando para mostrar no mapa:", {
        temLatitude: !!data.Latitude,
        temLongitude: !!data.Longitude,
        temMapRef: !!mapRef.current,
        temMarkersGroup: !!markersGroup.current
      });
    }
  };

  const aplicarFiltroOrganizacoes = async (Organizations: string[]) => {
    try {
      setSelectedOrganizations(Organizations);
      await fetchMqttData({
        organicoes: Organizations,
        Gateways: selectedGateways,
        Ativos: selectedAtivos
      }, selectedPage, selectedRows);
    } catch (error) {
      console.error("Erro ao aplicar filtro de organizações:", error);
    }
  };

  const aplicarFiltroGateways = async (Gateways: string[]) => {
    try {
      setSelectedGateways(Gateways);
      await fetchMqttData({
        organicoes: selectedOrganizations,
        Gateways: Gateways,
        Ativos: selectedAtivos
      }, selectedPage, selectedRows);
    } catch (error) {
      console.error("Erro ao aplicar filtro de gateways:", error);
    }
  };

  const aplicarFiltroAtivos = async (Ativos: string[]) => {
    try {
      setSelectedAtivos(Ativos);
      await fetchMqttData({
        organicoes: selectedOrganizations,
        Gateways: selectedGateways,
        Ativos: Ativos
      }, selectedPage, selectedRows);
    } catch (error) {
      console.error("Erro ao aplicar filtro de ativos:", error);
    }
  };

  async function exportTableToExcel() {
    const tableData = mainTableRef.current.getData();
    const filteredData = mainTableRef.current.getData("active");
    const visibleColumns = mainTableRef.current.getColumns().filter((col: ColumnComponent) => col.isVisible());

    const columnOrder: string[] = visibleColumns.map((col: ColumnComponent) => col.getField());

    const orderedData = filteredData.map((row: Record<string, any>) => {
      const orderedRow: Record<string, any> = {};
      columnOrder.forEach((field) => {
        if (row.hasOwnProperty(field)) {
          orderedRow[field] = row[field] ?? "";
        }
      });
      return orderedRow;
    });

    try {
      const endpoint = `${backendUrl}/Report/Excel`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderedData)
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Mqtt.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        console.log('Arquivo Excel baixado com sucesso!');
      } else {
        console.error('Erro ao baixar o arquivo Excel:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao fazer o POST:', error);
    }
  }

  return (
    <div className="d-flex" style={{ position: "relative" }}>
      <div style={{ width: sidebarVisible ? "80%" : "100%", transition: "0.3s" }}>
        <h1 className="ui header">Mqtt</h1>
        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          {/* Filtro de Organizações */}
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              isMulti
              value={selectedOrganizations.map(org => ({ label: org, value: org }))}
              options={initialOrganizations.map((org) => ({ label: org, value: org }))}
              onChange={(selectedOptions: any) => {
                const newOrgs = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
                setSelectedOrganizations(newOrgs);
                aplicarFiltroOrganizacoes(newOrgs);
              }}
              placeholder="Filtrar por Organização"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
          {/* Botões movidos para depois do filtro de organizações */}
          <button
            onClick={handleSettingsClick}
            className="button primary"
          >
            ⚙️ Configurações
          </button>
          <button
            onClick={() => {
              setSelectedOrganizations([]);
              setSelectedGateways([]);
              setSelectedAtivos([]);
              setSelectedPage(1);
              setSelectedRows(20);
              fetchMqttData({}, 1, 20);
              if (mainTableRef.current) {
                mainTableRef.current.clearHeaderFilter();
                mainTableRef.current.redraw(true);
              }
            }}
            className="button secondary"
          >
            🗑️ Limpar Filtros
          </button>
          <button
            className="button secondary"
            onClick={handleDownloadCsv}
          >
            <i className="ui icon arrow alternate circle down outline"></i>
            Download CSV
          </button>
          <button
            onClick={exportTableToExcel}
            className="button secondary"
          >
            <i className="ui icon file excel outline"></i>
            Download Excel
          </button>
          {/* Demais filtros movidos para depois dos botões */}
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              isMulti
              value={selectedGateways.map(gw => ({ label: gw, value: gw }))}
              options={availableGateways}
              onChange={(selectedOptions: any) => {
                const newGateways = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
                setSelectedGateways(newGateways);
                aplicarFiltroGateways(newGateways);
              }}
              placeholder="Filtrar por Gateway"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              isMulti
              value={selectedAtivos.map(ativo => ({ label: ativo, value: ativo }))}
              options={availableAtivos}
              onChange={(selectedOptions: any) => {
                const newAtivos = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
                setSelectedAtivos(newAtivos);
                aplicarFiltroAtivos(newAtivos);
              }}
              placeholder="Filtrar por Ativo"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
          {/* Filtros de paginação */}
          <div style={{ flex: 1, maxWidth: "150px" }}>
            <Select
              value={rowOptions.find(opt => opt.value === selectedRows)}
              options={rowOptions}
              onChange={(option: any) => {
                setSelectedRows(option.value);
                fetchMqttData({
                  organicoes: selectedOrganizations,
                  Gateways: selectedGateways,
                  Ativos: selectedAtivos
                }, selectedPage, option.value);
              }}
              placeholder="Linhas"
              isClearable={false}
              classNamePrefix="react-select"
            />
          </div>
          <div style={{ flex: 1, maxWidth: "120px" }}>
            <Select
              value={pageOptions.find(opt => opt.value === selectedPage)}
              options={pageOptions}
              onChange={(option: any) => {
                setSelectedPage(option.value);
                fetchMqttData({
                  organicoes: selectedOrganizations,
                  Gateways: selectedGateways,
                  Ativos: selectedAtivos
                }, option.value, selectedRows);
              }}
              placeholder="Página"
              isClearable={false}
              classNamePrefix="react-select"
            />
          </div>
        </div>
        {/* Tabela */}
        <div ref={tableRef}></div>
      </div>
      {/* Sidebar de Configurações */}
      {sidebarVisible && (
        <div className="sidebar-config">
          <h4 className="ui grey inverted header">
            <i className="ui cog icon"></i> Configurações da Tabela
          </h4>
          <div ref={configTableRef}></div>
          <button className="ui primary button" onClick={applyConfigChanges}>
            <i className="ui save icon"></i> Aplicar
          </button>
        </div>
      )}
      {detailsVisible && selectedPayload && (
        <div className="details-panel">
          <div className="header">
            <h3>Detalhes do Payload</h3>
            <i
              className="ui close icon close-icon"
              onClick={() => setDetailsVisible(false)}
            />
          </div>

          {/* Menu de abas */}
          <div className="tab-container">
            <button
              className={`tab-button ${activeTab === 'mapa' ? 'active' : ''}`}
              onClick={() => handleTabChange('mapa')}
            >
              <i className="map icon"></i>
              Mapa
            </button>
            <button
              className={`tab-button ${activeTab === 'payload' ? 'active' : ''}`}
              onClick={() => handleTabChange('payload')}
            >
              <i className="bell icon"></i>
              Payload
            </button>
          </div>

          {/* Conteúdo das abas */}
          <div className={`tab-content ${activeTab === 'mapa' ? 'active' : ''}`}>
            {activeTab === 'mapa' && (
              <div className="map-container">
                <MapContainer
                  center={[selectedPayload.Latitude || 0, selectedPayload.Longitude || 0]}
                  zoom={selectedPayload.Latitude && selectedPayload.Longitude ? 15 : 2}
                  className="map"
                  ref={(map) => {
                    if (map) {
                      // Atualiza a referência do mapa
                      mapRef.current = map;

                      // Remove o grupo de marcadores existente, se houver
                      if (markersGroup.current) {
                        mapRef.current.removeLayer(markersGroup.current);
                      }

                      // Cria um novo grupo de marcadores
                      markersGroup.current = L.layerGroup().addTo(mapRef.current);

                      // Adiciona o novo marcador
                      addMarkerToMap(selectedPayload);
                    }
                  }}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="OpenStreetMap">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; OpenStreetMap contributors'
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Satélite">
                      <TileLayer
                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        attribution="Tiles © Esri"
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Mapa Escuro">
                      <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                        attribution="&copy; CartoDB"
                      />
                    </LayersControl.BaseLayer>
                  </LayersControl>
                </MapContainer>
              </div>
            )}
          </div>
          <div className={`tab-content ${activeTab === 'payload' ? 'active' : ''}`}>
            {activeTab === 'payload' && (
              <div className="payload-container">
                <div className="payload-details">
                  <h4>Detalhes do Payload</h4>
                  <div className="payload-actions">
                    <button
                      className="button secondary"
                      onClick={() => {
                        const blob = new Blob([JSON.stringify(selectedPayload, null, 2)], { type: 'application/json' });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `payload_${selectedPayload.Tracking || 'data'}.json`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                      }}
                    >
                      <i className="ui icon download"></i>
                      Download JSON
                    </button>
                    <button
                      className="button secondary"
                      onClick={() => {
                        navigator.clipboard.writeText(JSON.stringify(selectedPayload, null, 2))
                          .then(() => {
                            // You might want to add a visual feedback here
                            alert('Payload copiado para a área de transferência!');
                          })
                          .catch(err => {
                            console.error('Erro ao copiar payload:', err);
                            alert('Erro ao copiar payload');
                          });
                      }}
                    >
                      <i className="ui icon copy"></i>
                      Copiar
                    </button>
                  </div>
                  <div className="payload-info">
                    <pre className="json-view">
                      {JSON.stringify(selectedPayload, null, 2)}
                    </pre>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuMqtt;
